import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://reledtnyzvkhegjqtgui.supabase.co";
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJlbGVkdG55enZraGVnanF0Z3VpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA5OTEzMzYsImV4cCI6MjA4NjU2NzMzNn0.UkY45aQ4OYJffHuS5RFI-iXbUCQYJJTOzWeir5E0EZg";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
